var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 33,
    viewBox: "0 0 110 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3 21H45.4V12.3H46.3V21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3 12.3V21H56.3L51.4 13.7H51.3V21H50.5V12.3H51.5L56.4 19.6H56.5V12.3H57.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 13.1V16.3H66V17H62.3V21H61.4V12.3H66.4V13.1H62.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8 21L72.5 17.2H70.7V21H69.9V12.3H72.8C74.4 12.3 75.4 13.2 75.4 14.7C75.4 16 74.6 16.8 73.4 17.1L75.8 21H74.8ZM70.7 16.4H72.6C73.8 16.4 74.5 15.7 74.5 14.7C74.5 13.6 73.8 13 72.6 13H70.7V16.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 18.4H80.5L79.7 21H78.8L81.8 12.3H82.9L85.9 21H85L84 18.4ZM83.8 17.7L82.3 13.3H82.2L80.7 17.7H83.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9 12.3L91.8 21H90.7L87.6 12.3H88.5L91.2 19.9H91.3L94 12.3H94.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 21H98.1V12.3H99V21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 18.4H104.1L103.3 20.9H102.4L105.4 12.2H106.5L109.5 20.9H108.6L107.6 18.4ZM107.3 17.7L105.8 13.3H105.7L104.2 17.7H107.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.2 30.9C6.4 30.9 0 24.5 0 16.6C0 8.69999 6.4 2.29999 14.3 2.29999C22.2 2.29999 28.6 8.69999 28.6 16.6C28.5 24.5 22.1 30.9 14.2 30.9ZM14.2 2.89999C6.7 2.89999 0.5 8.99999 0.5 16.6C0.5 24.2 6.7 30.3 14.2 30.3C21.7 30.3 28 24.2 28 16.6C28 8.99999 21.8 2.89999 14.2 2.89999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.1 32.6C9.20005 32.6 2.80005 26.2 2.80005 18.3C2.80005 10.4 9.20005 4 17.1 4C25 4 31.4001 10.4 31.4001 18.3C31.4001 26.2 25 32.6 17.1 32.6ZM17.1 4.6C9.50005 4.6 3.40005 10.8 3.40005 18.3C3.40005 25.8 9.60005 32 17.1 32C24.6 32 30.8 25.8 30.8 18.3C30.8 10.8 24.7 4.6 17.1 4.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 29.1C11.5 29.1 5.09998 22.7 5.09998 14.8C5.09998 6.9 11.5 0.5 19.4 0.5C27.3 0.5 33.7 7 33.7 14.9C33.7 22.7 27.3 29.1 19.4 29.1ZM19.4 1.1C11.8 1.1 5.69998 7.3 5.69998 14.8C5.69998 22.3 11.9 28.5 19.4 28.5C26.9 28.5 33.1 22.3 33.1 14.8C33.1 7.3 27 1.1 19.4 1.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e45c37022702c2e1978b1d91e9ec3b5.svg";
export { ForwardRef as ReactComponent };